import firebase from "../../Firebase";

/**
 * Colecciones que reciben hoja de consumo, moldes y tizado (de DDP).
 *
 * `tizadoDdp`/`tizadoDdpUrl` son el tizado que se carga desde DDP para
 * toda la OP. No confundir con el tizado propio de Corte
 * (`corte.otros[i].tizadoName`/`tizadoUrl`), que es por color y vive
 * anidado en cada entrada de `otros`; ese lo escribe CorteRegistroModal
 * directo, sin pasar por esta funcion.
 *
 * Inventario tomado de los bloques de propagacion de NewDdpRecord y
 * DirectNewDdpRecord. NO son las 8 colecciones vinculadas a una OP:
 *
 *   comercial ................ solo ficha tecnica (y en el campo `f`, no `b`)
 *   ing / ddp ................ ficha tecnica + hoja de consumo + moldes + tizadoDdp
 *   telas .................... ficha tecnica + hoja de consumo + moldes + tizadoDdp
 *   corte .................... ficha tecnica + hoja de consumo + moldes + tizadoDdp
 *   costura/acabados/almacen . solo ficha tecnica
 *
 * Ficha tecnica queda fuera de alcance y la siguen escribiendo los
 * formularios; esta funcion no la toca.
 */
const COLECCIONES = ["ing", "ddp", "telas", "corte"];

const LIMITE_BATCH = 450;

/**
 * Propaga los campos de archivos de una OP a los modulos que los muestran.
 *
 * @param {string} op numero de orden de produccion
 * @param {{hojaConsumo?: string, hc?: Array<{name: string, url: string}>,
 *          moldes?: string, moldesUrl?: Array<{name: string, url: string}>,
 *          tizadoDdp?: string, tizadoDdpUrl?: Array<{name: string, url: string}>}} campos
 *        Solo se escriben las claves presentes.
 * @returns {Promise<void>}
 */
const propagarArchivosDeOp = async (op, campos) => {
  // Firestore rechaza `undefined` en where(), con un error que no dice nada
  // util. Fallar aqui nombra el problema real: no llego la OP.
  if (!op) {
    throw new Error(
      "propagarArchivosDeOp requiere una orden de produccion; se recibio: " +
        JSON.stringify(op)
    );
  }

  const db = firebase.firestore();

  const payload = {};
  Object.keys(campos || {}).forEach((clave) => {
    if (campos[clave] !== undefined) payload[clave] = campos[clave];
  });
  if (!Object.keys(payload).length) return;

  // Las cuatro consultas son independientes: en paralelo cuestan una ida y
  // vuelta en vez de cuatro.
  const snaps = await Promise.all(
    COLECCIONES.map((nombre) =>
      db
        .collection(nombre)
        .where("op", "==", op)
        .get()
    )
  );

  const escrituras = snaps.reduce((total, snap) => total + snap.size, 0);
  if (!escrituras) return;

  // Antes de encolar: pasado el limite, `batch.update()` falla con un error
  // opaco del SDK y este mensaje no llegaria a verse.
  if (escrituras > LIMITE_BATCH) {
    throw new Error(
      `La OP ${op} tiene ${escrituras} documentos vinculados, cerca del limite ` +
        `de 500 escrituras por batch de Firestore. Revise los datos antes de continuar.`
    );
  }

  const batch = db.batch();
  snaps.forEach((snap) => snap.forEach((doc) => batch.update(doc.ref, payload)));

  await batch.commit();
};

export default propagarArchivosDeOp;
